import React, { memo } from "react";
import { Popover } from "@mui/material";
import "./styles.scss";

export interface IPopoverComponent {
  children: React.ReactNode;
  customStyles?: any;
  id?: string;
  open: boolean;
  handleClose: () => void;
  anchorEl?: null | Element | ((element: Element) => Element);
}

const PopoverComponent = ({
  id,
  children,
  open,
  handleClose,
  anchorEl,
}: IPopoverComponent) => {
  return (
    <Popover
      className="custom_popover"
      id={id}
      open={open}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      onClose={handleClose}
      anchorEl={anchorEl}
    >
      {children}
    </Popover>
  );
};

export default memo(PopoverComponent);
